import { render, staticRenderFns } from "./AdvisorNotes.vue?vue&type=template&id=ae55b24c&scoped=true&lang=pug"
import script from "./AdvisorNotes.vue?vue&type=script&lang=ts"
export * from "./AdvisorNotes.vue?vue&type=script&lang=ts"
import style0 from "./AdvisorNotes.vue?vue&type=style&index=0&id=ae55b24c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae55b24c",
  null
  
)

export default component.exports